import { render } from "./ConfirmGoods.vue?vue&type=template&id=2dc0c463&scoped=true"
import script from "./ConfirmGoods.vue?vue&type=script&lang=js"
export * from "./ConfirmGoods.vue?vue&type=script&lang=js"

import "./ConfirmGoods.vue?vue&type=style&index=0&id=2dc0c463&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dc0c463"]])

export default __exports__